import { ClickOutside } from '@/plugins-ts'
import { createApp, type App, type Component } from 'vue'

//Modals
import AlertPopup from '@/components/Shared/PopUp/Alert.vue'
import ConfirmPopup from '@/components/Shared/PopUp/Confirm.vue'
import InputPopup from '@/components/Shared/PopUp/InputConfirm.vue'
import NotePopup from '@/components/Shared/PopUp/Note.vue'
import ToastPopup from '@/components/Shared/PopUp/Toast.vue'
import type { IAlert, IConfirm, IInputConfirm, INote, IToast } from '@/types/Components/Popup'

export const Alert = (props: IAlert) => {
  return new Promise(resolve => {
    defineAppInstance(AlertPopup, resolve, props, 'ui-custom-alert', true)
  })
}

export const InputConfirm = (props: IInputConfirm) => {
  return new Promise(resolve => {
    defineAppInstance(InputPopup, resolve, props, 'ui-custom-input-confirm', false)
  })
}

export const Note = (props: INote) => {
  return new Promise(resolve => {
    defineAppInstance(NotePopup, resolve, props, 'ui-custom-note', false)
  })
}

export const Confirm = (props: IConfirm) => {
  return new Promise(resolve => {
    defineAppInstance(ConfirmPopup, resolve, props, 'ui-custom-confirm', false)
  })
}

export const Toast = (props: IToast) => {
  return new Promise(resolve => {
    defineAppInstance(ToastPopup, resolve, props, 'ui-custom-toast', true)
  })
}

const defineAppInstance = (
  component: Component,
  resolve: (value: any) => void,
  props: any,
  tag: string,
  hasTimer: boolean,
) => {
  const app = createApp(component, {
    ...props,
    onResponse(value: any) {
      resolve(value)
      app.unmount()

      const el = document.getElementById(tag)
      if (!value && el) {
        el.remove()
      }
    },
  })

  defineDirectives(app)

  const componentDiv = document.createElement('div')
  componentDiv.setAttribute('id', tag)
  document.body.appendChild(componentDiv)

  app.mount(componentDiv)

  const isExist = document.getElementById(tag)

  if (hasTimer) {
    setTimeout(() => {
      resolve(true)
      if (isExist) {
        isExist.remove()
      }
      app.unmount()
    }, props.timer ?? 3000)
  }
}

const defineDirectives = (app: App) => {
  app.directive('click-outside', ClickOutside)
}
